export const environment = {
    production: true,
    env: 'dev',
    ROOT_URL: 'https://dev-tnb-tdl.nonprod.k8s.eon.com',
    API_URL: '/api',
    oauth: {
        redirectUrl: window.location.origin + window.location.pathname,
        loginUrl: 'https://westnetz-tnb-portal-dev.eon-ciam-dev.auth0app.com/authorize' +
            '?response_type=code' +
            '&client_id=O1IYI4KsR3xpfwG5ONWro2pPZqM49fvC' +
            '&scope=offline_access' +
            '&audience=urn:westnetz:tnbportal:tnbtdl:backend:dev' +
            '&redirect_uri=https://dev-tnb-tdl.nonprod.k8s.eon.com',
        logoutUrl: 'https://westnetz-tnb-portal-dev.eon-ciam-dev.auth0app.com/v2/logout' +
            '?client_id=O1IYI4KsR3xpfwG5ONWro2pPZqM49fvC' +
            '&returnTo=https://dev-tnb-tdl.nonprod.k8s.eon.com',
    },
    sentry: {
        dsn: 'https://874d9700e8be4556a259d8488dc74b29@sentry.eon.com/77',
        environment: 'dev',
        enabled: true,
    },
};
